import { Box, Typography } from '@mui/material'
import type { FC } from 'react'

interface TimelineEntryProps {
  readonly title: string
  readonly role?: string
  readonly date: string
  readonly description: string
  readonly isCurrent?: boolean
}

const TimelineEntry: FC<TimelineEntryProps> = ({
  title,
  role,
  date,
  description,
  isCurrent = false
}) => {
  return (
    <Box
      className={`timeline-entry${isCurrent ? ' timeline-entry--current' : ''}`}
      component='article'
    >
      <Typography className='timeline-entry__date' component='time'>
        {date}
      </Typography>
      <Box className='timeline-entry__body'>
        <Typography className='timeline-entry__title' component='h3' variant='subtitle1'>
          {title}
        </Typography>
        {role != null && (
          <Typography className='timeline-entry__role' variant='body2'>
            {role}
          </Typography>
        )}
        <Typography className='timeline-entry__description' variant='body2'>
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default TimelineEntry
